<template>
  <div id="Contact">
    <b-container class="content-container">
      <h3>
        {{
          languageHelper.translate("common.contact", { locale: global.locale })
        }}
      </h3>
    </b-container>
  </div>
</template>

<script>
import { languageHelper } from "@/helpers";
import { mapState } from "vuex";

export default {
  name: "Contact",
  data() {
    return {
      languageHelper,
    };
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
#Contact {
  width: 100%;
  height: 90vh;
  max-height: 600px;
  z-index: 5;
  background: #fff;
  padding-top: 100px;
  padding-bottom: 100px;
  background-image: url("~@/assets/images/backgrounds/contact.png");
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 800px) {
    height: 50vh;
  }

  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
  }
  h3 {
    font-family: $font-primary;
    font-size: 50px;
  }
}
</style>

<style lang="scss" >
.dark {
  #Contact {
    background-color: $dt-bg-color;

    h3 {
      color: $dt-font-color;
    }
  }
}
</style>

